import { FaExclamationTriangle } from 'react-icons/fa';

import useFormatMessage from '../../hooks/useFormatMessage';

import c from '../../utils/c';

export function WarningNotification({ className = '', content, title = null }) {
  const t = useFormatMessage();

  return (
    <div
      className={c(
        className,
        'w-full max-w-sm bg-orange-600 py-3 px-3 text-white flex rounded',
      )}
    >
      <div className="mt-1 mr-2">
        <FaExclamationTriangle />
      </div>
      <div>
        <div className="uppercase font-bold mb-px">
          {title || t('notifications.warning.label')}
        </div>
        <div>{content}</div>
      </div>
    </div>
  );
}
